export enum MotivatorReqKeys {
  last = 'last',
  bestLast = 'bestLast',
  bigOpens = 'bigOpens',
  bestDrop = 'bestDrop',
  count = 'count',
}
